import React, { useState, useEffect } from "react";
// import configuration from "../../../config";
// import { toast } from "react-toastify";
import Loader from "../../../components/Loader/Loader";

// Dynamic class
// function classNames(...classes) {
//   return classes.filter(Boolean).join(" ");
// }
// let Id = "";
// List Settings
function Summary({ data }) {
  const [isLoader, setIsLoader] = useState(false);
  const [actions, setActions] = useState({
    bank_detail: {
      account_holder: "",
      account_number: "",
      bank_code: "",
      bank_location: "",
      bank_name: "",
    },
  });
  useEffect(() => {
    // var url = window.location.href;
    // Id = url.substring(url.lastIndexOf("/") + 1);
    // configuration
    //   .getAPI({ url: "sub-user/detail", params: { user_id: Id } })
    //   .then((data) => {
    //     if (data.status === 200) {
    setIsLoader(true);
    setActions(data);
    setIsLoader(false);
    //   }
    // })
    // .catch((error) => {
    //   return toast.error(error.message);
    // });
  }, []);

  return (
    <div className="md:pl-8 sm:py-7 col-span-10">
      {isLoader ? <Loader /> : ""}

      <section aria-labelledby="applicant-information-title">
        <div className="bg-white shadow sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6">
            <h2
              id="applicant-information-title"
              className="text-lg leading-6 font-medium text-gray-900"
            >
              Bank Details
            </h2>
            <p className="mt-1 max-w-2xl text-base text-gray-500 text_theme">
              This information shows the partner's bank details.
            </p>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
            <div className="">
              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div className="sm:col-span-1">
                  <dt className="text-basefont-medium text-gray-500">
                    Account Holder Name:
                  </dt>
                  <dd className="mt-1 text-base text-gray-900 md:break-all">
                    {actions.bank_detail.account_holder}
                  </dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-basefont-medium text-gray-500">
                    Account Number:
                  </dt>
                  <dd className="mt-1 text-base text-gray-900 md:break-all">
                    {actions.bank_detail.account_number}
                  </dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-basefont-medium text-gray-500">
                    Branch Code:
                  </dt>
                  <dd className="mt-1 text-base text-gray-900 md:break-all">
                    {actions.bank_detail.bank_code}
                  </dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-basefont-medium text-gray-500">
                    Address:
                  </dt>
                  <dd className="mt-1 text-base text-gray-900 md:break-all">
                    {actions.bank_detail.bank_location}
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Summary;
